import { LOGIN_SITE } from '~/lib/constants/constants'
import { useViewer } from '../../store/stateMachine/state'

export const IkyuOnlyYidLoginMessage =
  import.meta.env.VITE_MODE === 'ppg' ? EmptyYidLoginMessage : YidLoginMessage

function YidLoginMessage() {
  const isYidLogin = useViewer()?.loginSite === LOGIN_SITE.Yahoo
  if (!isYidLogin) {
    return null
  }
  return (
    <p className="px-3 text-neutral-700">
      Yahoo! JAPAN
      IDでログインの場合、一休ポイントはご利用いただけません。一休ポイントのご利用には一休アカウントでのログインが必要です。
    </p>
  )
}

function EmptyYidLoginMessage() {
  return null
}
